import { ImageEntity } from "@client/content/controls/Image/container";
import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import classnames from "classnames";
import React from "react";
import { type BlogDetailHeader } from "../types";
import Title from "./Title/container";

export type BlogDetailPostProps = RootContainerProps & {
  post: BlogDetailHeader.Post;
  overlayStyle: React.CSSProperties;
  settings: BlogDetailHeader.View.PostSettings;
};

export default ({ post, settings, overlayStyle, ...rootProps }: BlogDetailPostProps) => (
  <div
    className={classnames("post-container", {
      "title-over": settings.titlePosition === "OverCenter",
      "title-above": settings.titlePosition === "TopLeft",
      "title-below": settings.titlePosition === "BottomLeft"
    })}
  >
    {settings.titlePosition === "TopLeft" ? <Title {...rootProps} /> : null}
    {!post.imageUrl ? null : (
      <div className={classnames("post-image")}>
        <ImageEntity {...getEntityRef(rootProps)} src={post.imageUrl} />
        <div className="post-image-overlay" style={overlayStyle} />
        {settings.titlePosition === "OverCenter" ? <Title {...rootProps} /> : null}
      </div>
    )}
    {settings.titlePosition === "BottomLeft" ? <Title {...rootProps} /> : null}
  </div>
);
